import React, { ChangeEvent, ReactElement, useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { IAppState } from '../../../core/store/store'
import { IEditUserOwnProps, IEditUserStateProps, TEditUserProps } from './EditUser.types'
import { capitalize, get, omit } from 'lodash-es'
import { editUser, fetchUserById } from '../../../core/actions/Users.actions'
import { destroyForm } from '../../../core/actions/Common'
import { fetchPermissions, fetchUserApplications } from '../../../core/actions/Profile.actions'
import { fetchTenantById } from '../../tenants/Tenants.actions'
import { withPermissionsHOC } from '../../../core/hoc/permissionsHoc'
import {
  Accordion,
  Button,
  ButtonType,
  Collapse,
  Form,
  FormFieldSize,
  FormGroup,
  IncontextBanner,
  Input,
  InputType,
  MultiSelect,
  Option,
  Select,
  Stepper,
  SubmitButton,
  Tag,
  TagType,
  Tooltip
} from '@digicert/dcone-common-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock, faPencil } from '@fortawesome/pro-light-svg-icons'
import styles from './EditUser.module.scss'
import { Translate } from 'react-localize-redux'
import { getManagerName, mapOptionsCommonUi, mapUserPermission, renderManagerIcon, translate } from '../../../shared/helpers/utils'
import { EMAIL_REGEXP, NAME_REGEXP, RouterConfig, USER_NAME_REGEXP } from '../../../core/utils/constants'
import { getPermissions } from '../../../core/selectors/Profile.selectors'
import UserForm from '../user-form'
import { FormMode } from '../../../shared/interfaces'
import NoPermissionsPage from '../../../shared/components/no-permissions-page'
import { IUserFormValues } from '../user-form/UserForm.types'
import { UserFormAdapter } from '../user-form/UserForm.constants'
import history from '../../../core/history/history'
import { IAccessScope } from '../../../reducers/Reducers.interfaces'
import cn from 'classnames'
import { fetchRoles } from '../manage-roles/ManageRoles.actions'
import { Link } from 'react-router-dom'
import { checkIfUsernameExists } from 'public-pages/self-service-user/SelfServiceUser.actions'
import { fetchUserRoleById } from '../edit-role/EditRole.actions'
import { AccountFeatures, STMApplicationName } from 'core/constants'

const EditUser = (
  {
    destroyForm,
    editUser,
    fetchPermissions,
    fetchUserById,
    checkIfUsernameExists,
    fetchUserRoleById,
    fetchRoles,
    fetchUserApplications,
    features,
    localeList,
    location,
    match,
    permissions,
    userApplications,
    profile
  }: TEditUserProps): ReactElement => {
  const [accounts, setAccounts] = useState<any>([])
  const [allAccounts, setAllAccounts] = useState<any>([])
  const [currentPage, setCurrentPage] = useState(0)
  const [currentUser, setCurrentUser] = useState<any>({})
  const [accessScope, setAccessScope] = useState(false)
  const [userAccessError, setUserAccessError] = useState(false)
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [userName, setUserName] = useState('')
  const [samlUserName, setSamlUserName] = useState('')
  const [oidcUserName, setOidcUserName] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [language, setLanguage] = useState('en_US')
  const [loaded, setLoaded] = useState(false)
  const [featureIds, setFeatureIds] = useState<string[]>([])
  const [editingDisabled, setEditingDisabled] = useState(true)
  const [roles, setRoles] = useState<any>([])
  const [managers, setManagers] = useState<any>([])
  const [managerRoles, setManagerRoles] = useState<any>([])
  const [, setToolTipIndex] = useState(-1)
  const [roleDetails, setRoleDetails] = useState<any>([])
  const appInfo = new Map()
  const [applicationIcons, setApplicationIcons] = useState(appInfo)
  const [userNameExists, setUserNameExists] = useState(false)
  const [samlNameExists, setSamlNameExists] = useState(false)
  const [oidcNameExists, setOidcNameExists] = useState(false)
  const [keyLockerEnabled, setKeyLockerEnabled] = useState(false)
  const [disableAccountValidation, setDisableAccountValidation] = useState(false)

  const onStepChange = (currentPage) => {
    setCurrentPage(currentPage)
  }

  const getAllAccounts = () => {
    const options = allAccounts.map((account) => {
      const hasPermissionToAccount = profile?.accounts.some(item => item.id === account.id);
      return {
        label: account.name,
        value: account.id,
        disabled: account.id === currentUser.primary_account_id || !hasPermissionToAccount,
        featureIds: account.enabled_feature_ids
      }
    })
    options?.sort((a, b) => (a.label > b.label ? 1 : -1))
    return options
  }

  const clearAccounts = () => {
    const tmpArray: any = []
    setDisableAccountValidation(true)
    setTimeout(() => {
      getAllAccounts()?.map((item) => {
        if (item.value === currentUser.primary_account_id && item.disabled) {
          tmpArray.push(item.value)
          setAccounts(tmpArray)
          setDisableAccountValidation(false)
        }
      })
    })
  }

  const validateMultiSelect = (): any => {
    if(!disableAccountValidation) {
      return accounts.length === 0 ? translate('common.form.validation.required') : ''
    }
  }

  const handleMultiSelect = (value): void => {
    setAccounts(value)
    let array: any = featureIds
    value.forEach(element => {
      const selectedAccount = getAllAccounts()?.find(item => item.value === element)
      array = array.concat(selectedAccount.featureIds)
    });
    setFeatureIds(array)
  }

  const onFirstNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setFirstName(event.target.value)
  }

  const onLastNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setLastName(event.target.value)
  }

  const onEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value)
  }

  const onSamlUserNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSamlUserName(event.target.value)
    checkIfUsernameExists(event.target.value, undefined, 'ssoUserName', match.params.id).then((response:boolean) => {
      setSamlNameExists(response)
    })
  }

  const onOidcUserNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setOidcUserName(event.target.value)
    checkIfUsernameExists(event.target.value, undefined, 'oidcUserName', match.params.id).then((response:boolean) => {
      setOidcNameExists(response)
    })
  }

  const onUserNameFocus = () => {
    if (userName === '') {
      setUserName(email)
    }
    else {
      setUserName(userName)
    }
  }

  const validateUserName = (): any => {
    if (userNameExists) {
      return translate('notifications.exceptions.USERNAME_EXISTS');
    }
  }

  const onUserNameChange = useCallback(
    (event) => {
      setUserName(event.target.value)
      checkIfUsernameExists(event.target.value, undefined, 'userName', match.params.id).then((response:boolean) => {
        setUserNameExists(response)
      })
    },
    [checkIfUsernameExists]
  )

  const validateSamlUserName = (): any => {
    if (samlNameExists) {
      return translate('notifications.exceptions.USERNAME_EXISTS');
    }
  }

  const validateOidcUserName = (): any => {
    if (oidcNameExists) {
      return translate('notifications.exceptions.USERNAME_EXISTS');
    }
  }

  const onPhoneChange = (value) => {
    value ? setPhoneNumber(value) : setPhoneNumber('')
  }

  const onLangChange = (lang: any): void => {
    setLanguage(lang)
  }

  const validateLangSelect = (): any => !language ? translate('common.form.validation.required') : ''

  const proceedToPermissions = (e) => {
    e.preventDefault()
    setCurrentPage(currentPage + 1)
  }

  const formatAccountArrayForPayload = () => {
    // all accounts the user being edited has access too
    const selectedAccounts = accounts.map(id => getAllAccounts()?.find(obj => obj.value == id));

    // singed-in user accounts
    let filteredAccounts: any[] = [];

    // map through selected accounts and push only accounts singed-in user has access too
    selectedAccounts.map(item => {
      if (profile?.accounts.some(account => account.id && account.id === item.value)) {
        filteredAccounts.push(item)
      }
    });

    // format data set to be compatible with payload
    filteredAccounts = filteredAccounts.map(item => {
      return {
        id: item.value,
        name: item.label
      };
    });

    return filteredAccounts
  }

  const cancelEditingUser = (e) => {
    e.preventDefault()
    history.goBack()
  }

  const cancelEditingPermissions = () => {
    setEditingDisabled(true)
  }

  const submitModifiedPermissions = (formValues: IUserFormValues) => {
    const formData = {
      ...omit(formValues, ['user', 'allPermissions']),
      access_scope: accessScope,
      accounts: accessScope ? [] : formatAccountArrayForPayload(),
      permissions: mapUserPermission(formValues.permissions),
      locale: language,
      first_name: firstName,
      last_name: lastName,
      email: email,
      user_name: userName,
      language: localeList?.locales.find(item => item.id === language),
      phone: phoneNumber,
      saml_username: samlUserName,
      oidc_username: oidcUserName
    }
    editUser(match.params.id, formData, features.roles).then(() => {
      setEditingDisabled(true)
      history.goBack()
    })
  }

  const editPermissions = useCallback(
    () => setEditingDisabled(!editingDisabled),
    [editingDisabled]
  )

  const getAllManagers = () => {
    let managerOptions = userApplications?.map((option) => {
      return {
        label: option.app_name,
        value: option.id,
        name: option.name,
        app: option.app_code
      }
    })

    if (!accessScope) {
      managerOptions = managerOptions?.filter(options => (options.app !== 'organization_validation' && options.app !== 'individual_validation'))
    }

    managerOptions?.sort((a, b) => (a.label > b.label ? 1 : -1))

    return managerOptions
  }

  const getManagerRoles = (managerId: string) => {
    const rolesData: Array<any> = []
    const managerName = getAllManagers()?.filter(m => m.value === managerId)[0].app
    Object.keys(roles).forEach(
      (key, val) => {
        if (key === managerName) {
          return roles[key].map(role => {
            const roleData = {
              label: role.type === 'default' ? translate(`manageUserRoles.name.${role.name}`) : role.display_name,
              value: role.id,
              description: role.type === 'default' ? translate(`manageUserRoles.description.${role.name}`) : role.description,
              application: role.application_id
            }
            rolesData.push(roleData)
          })
        }
      })
    return rolesData
  }

  const submitUser = (e) => {
    e.preventDefault()
    const roles = managerRoles.flat()
    const filteredRoles = roles.filter((item, index) => roles.indexOf(item) === index);
    const formData = {
      access_scope: accessScope,
      accounts: accessScope ? [] : formatAccountArrayForPayload(),
      locale: language,
      first_name: firstName,
      last_name: lastName,
      email: email,
      user_name: userName,
      language: localeList?.locales.find(item => item.id === language),
      phone: phoneNumber,
      saml_username: samlUserName,
      oidc_username: oidcUserName,
      roles: filteredRoles
    }
    editUser(match.params.id, formData, false).then(() => {
      destroyForm(UserFormAdapter.name).then(() => {
        history.push(RouterConfig.administrators.table)
      })
    })
  }

  const displayToolTip = (index: any) => {
    setToolTipIndex(index)
  }

  const handleManagerRoleSelect = (value): void => {
    const roles = [...managerRoles]
    roles.push(value)
    setManagerRoles(roles)
  }

  const handleClearMultiSelect = (value): void => {
    const roles = managerRoles.flat()
    const filteredRoles = roles.filter((item,
                                        index) => roles.indexOf(item) === index);
    const index = filteredRoles.indexOf(value);
    if (index !== -1) {
      filteredRoles.splice(index, 1);
    }
    setManagerRoles(filteredRoles)
  }

  const validateManagerRoleSelect = (): string => {
    if (Array.isArray(managerRoles) && managerRoles.length === 0) {
      return translate('manageUser.administrators.form.selectOneRole') as string
    }
    else {
      return ''
    }
  }

  const handleMultiManagerSelect = (value): void => {
    setManagers(value)
  }

  const validateMultiManagerSelect = (): string => {
    if (Array.isArray(managers) && managers.length === 0) {
      return translate('manageUser.administrators.form.selectOneManager') as string
    }
    else return ''
  }

  useEffect(() => {
    destroyForm(UserFormAdapter.name).then()
  }, [UserFormAdapter.name])

  useEffect(() => {
    fetchUserById(match.params.id).then((response) => {
      if (response.access_scope === IAccessScope.account) {
        fetchPermissions(response.access_scope.toUpperCase(), response.primary_account_id)
      } else {
        fetchPermissions(response.access_scope.toUpperCase())
      }

      setCurrentUser(response)
      setFirstName(response.first_name)
      setLastName(response.last_name)
      setEmail(response.email)
      setUserName(response.user_name)
      setSamlUserName(response.saml_username)
      setOidcUserName(response.oidc_username)
      setLanguage(response.locale)
      setAccessScope(response.access_scope === IAccessScope.system)
      if (profile && response.access_scope === IAccessScope.account) {
        const keylockerFeatureEnabled = profile.accounts.filter(acc => acc.id === response.primary_account_id)[0].enabled_feature_ids.includes(AccountFeatures.STM_KEYLOCKER_ACCOUNT)
        setKeyLockerEnabled(keylockerFeatureEnabled)
        if (keylockerFeatureEnabled && userApplications && userApplications.find(app => app.name === STMApplicationName.SECURE_SOFTWARE)) {
          fetchUserApplications(response.primary_account_id)
        }
      }
      if (features.roles) {
        const applications = Object.keys(response.applications).sort((a, b) => (a > b ? 1 : -1))
        const managers: Array<string> = []
        applications.forEach(
          (key) => {
            managers.push(response.applications[key].id)
            appInfo.set(response.applications[key].app_name, response.applications[key].icon)
          })
        setManagers(managers)
        setApplicationIcons(appInfo)
        if (response.access_scope !== IAccessScope.system) {
          const filter = '&scope=ACCOUNT&status=ACTIVE&accountId=' + response.primary_account_id
          fetchRoles(filter).then(res => {
            setRoles(res)
          })
        } else {
          const filter = '&scope=SYSTEM'
          fetchRoles(filter).then(res => {
            setRoles(res)
          })
        }
      }
      const accessibleAccounts: any[] = [];
      for (let i = 0; i < response.accounts.length; i++) {
        accessibleAccounts.push(response.accounts[i].id)
      }
      setAccounts(accessibleAccounts)

      if (response.phone) {
        setPhoneNumber(response.phone)
      }
      setLoaded(true)
    })
    .catch((error: any) => {
      if (error.message.includes('userAccessError')) {
        setUserAccessError(true)
      }
    })
  }, [])

  useEffect(() => {
    if (managerRoles.length >= 1) {
      const rolesData: Array<any> = []
      const roles = managerRoles.flat()
      const filteredRoles = roles.filter((item, index) => roles.indexOf(item) === index);
      fetchUserRoleById(filteredRoles, !accessScope ? currentUser.primary_account_id : undefined).then((res) => {
        if (res) {
          res.map(role => {
            const permissionGroups: Array<any> = []
            Object.keys(role.permission_groups).forEach((key, val) => {
              permissionGroups.push(
                {
                  permissionGroupCategory: translate(`createUserRole.permissions.category.${key}`) as string,
                  permissionGroups: role.permission_groups[key].map(value => {
                    return translate(`createUserRole.permissions.permissionGroups.${value}`) as string
                  })
                })
            })
            const roleDetails = {
              icon: renderManagerIcon(applicationIcons.get(role.application.name), role.application.name),
              name: role.type === 'default' ? translate(`manageUserRoles.name.${role.name}`) : role.display_name,
              type: capitalize(role.type),
              description: role.type === 'default' ? translate(`manageUserRoles.description.${role.name}`) : role.description,
              permissionsGroups: permissionGroups,
              application: role.application.id,
              id: role.id
            }
            rolesData.push(roleDetails)
          })
        }
        setRoleDetails(rolesData)
      })
    } else {
      setRoleDetails([])
    }
  }, [managerRoles])


  useEffect(() => {
    if (profile && Object.keys(currentUser).length !== 0) {
      const merged = [...profile.accounts, ...currentUser.accounts]
      const filteredArray = merged.filter((v, i, a) => a.findIndex(item => (item.id === v.id)) === i)
      setAllAccounts(filteredArray)
      if (currentUser.access_scope === IAccessScope.account) {
        setFeatureIds(currentUser.accounts.find(acc => acc.id === currentUser.primary_account_id).enabled_feature_ids)
      }
    }
  }, [profile, currentUser])

  if (!permissions.canManageAccountUser && !permissions.canManageSystemUser) {
    return (
      <NoPermissionsPage />
    )
  }

  if (currentUser && currentUser.status !== 'ACTIVE' || userAccessError) {
    if (loaded) {
      return (
        <NoPermissionsPage />
      )
    }
    else return <></>
  }

  return (
    <>
      <div className={styles.stepWrapper}>
        <Stepper
          headline={<h1>{translate('manageUser.administrators.form.editAdmin')}</h1>}
          currentStep={currentPage}
          stepContentMaxWidth={400}
          onStepChange={onStepChange}
          stepData={[
            {
              label: translate('manageUser.administrators.form.nameAccessRights'),
              icon: <FontAwesomeIcon size='lg' icon={faPencil} />
            },
            {
              label: translate('manageUser.administrators.form.adminPermissionsStepLabel'),
              icon: <FontAwesomeIcon size='lg' icon={faClock} />
            }
          ]}
        />
      </div>

      {currentPage === 0 && currentUser && (
        <section className={styles.editUser}>
          <h4>
            <Translate id='common.userDetails' />
          </h4>

          <Form center={false} onSubmit={(e) => { proceedToPermissions(e) }}>
            {currentUser.access_scope !== IAccessScope.system && (
              <FormGroup>
                <MultiSelect
                  getPopupContainer={(triggerNode) => triggerNode.parentElement}
                  help=''
                  label={translate('common.form.account') as string}
                  placeholder={translate('common.form.select')}
                  value={accounts}
                  defaultValue={accounts}
                  onChange={handleMultiSelect}
                  allowClear
                  size={FormFieldSize.L}
                  options={getAllAccounts()}
                  validate={validateMultiSelect}
                  tooltipProps={{
                    title: translate('common.form.validation.signInAccountNoAccess')
                  }}
                  onClear={clearAccounts}
                />
              </FormGroup>
            )}

            <FormGroup>
              <div className={styles.nameGroup}>
                <Input
                  label={translate('common.form.firstName')}
                  required
                  minLength={1}
                  maxLength={256}
                  value={firstName}
                  onChange={onFirstNameChange}
                  pattern={NAME_REGEXP}
                  errors={{
                    valueMissing: translate('common.form.validation.required')
                  }}
                  id='first_name'
                />

                <Input
                  label={translate('common.form.lastName')}
                  required
                  minLength={1}
                  maxLength={256}
                  value={lastName}
                  pattern={NAME_REGEXP}
                  onChange={onLastNameChange}
                  errors={{
                    valueMissing: translate('common.form.validation.required')
                  }}
                  id='last_name'
                />
              </div>
            </FormGroup>

            <FormGroup>
              <Input
                size={FormFieldSize.L}
                label={<Translate id='common.form.email' />}
                required
                value={email}
                onChange={onEmailChange}
                pattern={EMAIL_REGEXP}
                errors={{
                  typeMismatch: translate('notifications.errors.invalidEmailError'),
                  valueMissing: translate('common.form.validation.required'),
                  patternMismatch: translate('notifications.errors.invalidEmailError')
                }}
              />
            </FormGroup>

            <FormGroup>
              <Input
                size={FormFieldSize.L}
                label={<Translate id='common.form.username' />}
                required
                value={userName}
                pattern={USER_NAME_REGEXP}
                errors={{
                  valueMissing: translate('common.form.validation.required'),
                  patternMismatch: translate('common.form.validation.invalidUserName')
                }}
                onChange={onUserNameChange}
                onFocus={onUserNameFocus}
                validate={validateUserName}
              />
            </FormGroup>

            {currentUser.sign_in_method.signInMethod === 'singleSignOnSaml' && currentUser.sign_in_method.status === 'enabled' && (
              <FormGroup>
                <Input
                  size={FormFieldSize.L}
                  label={<Translate id='common.form.samlUsername' />}
                  required
                  value={samlUserName}
                  pattern={USER_NAME_REGEXP}
                  errors={{
                    valueMissing: translate('common.form.validation.required'),
                    patternMismatch: translate('common.form.validation.invalidUserName')
                  }}
                  onChange={onSamlUserNameChange}
                  validate={validateSamlUserName}
                />
              </FormGroup>
            )}

            {currentUser.sign_in_method.signInMethod === 'singleSignOnOidc' && currentUser.sign_in_method.status === 'enabled' && (
              <FormGroup>
                <Input
                  size={FormFieldSize.L}
                  label={<Translate id='common.form.oidcUsername' />}
                  required
                  value={oidcUserName}
                  pattern={USER_NAME_REGEXP}
                  errors={{
                    valueMissing: translate('common.form.validation.required'),
                    patternMismatch: translate('common.form.validation.invalidUserName')
                  }}
                  onChange={onOidcUserNameChange}
                  validate={validateOidcUserName}
                />
              </FormGroup>
            )}

            <FormGroup>
              <Input
                size={FormFieldSize.L}
                label={translate('common.form.phoneOptional')}
                type={InputType.TELEPHONE}
                validateChanges
                value={phoneNumber}
                errors={{ valueMissing: translate('common.form.validation.required') }}
                onChange={onPhoneChange}
              />
            </FormGroup>

            <FormGroup>
              <Select
                getPopupContainer={(triggerNode) => triggerNode.parentElement}
                size={FormFieldSize.L}
                allowClear
                defaultValue={'English'}
                value={language}
                label={translate('profile.language')}
                onChange={onLangChange}
                options={localeList ? mapOptionsCommonUi(localeList.locales) : []}
                errors={{ valueMissing: translate('common.form.validation.required') }}
                validate={validateLangSelect}
                optionFilterProp="label"
                showSearch
              />
            </FormGroup>

            <div className={styles.formActions}>
              <Button buttonType={ButtonType.SECONDARY} onClick={(e) => { cancelEditingUser(e) }}>
                <Translate id='common.form.buttons.cancelBtn' />
              </Button>

              <SubmitButton disabled={currentUser.access_scope !== IAccessScope.system && accounts.length === 0}>
                <Translate id='common.form.buttons.nextBtn' />
              </SubmitButton>
            </div>
          </Form>
        </section>
      )}

      {currentPage === 1 && currentUser && (
        <section className={styles.editUserPermissions}>
          <div className={cn(styles.headlineContainer, !editingDisabled && styles.dimmed)}>
            <h2 className={styles.headline}><Translate id='manageUser.administrators.form.editAdmin' /></h2>
          </div>
          {!features.roles &&
          <UserForm
            mode={FormMode.edit}
            user={currentUser}
            location={location}
            goBack={() => setCurrentPage(0)}
            onCancel={() => history.goBack()}
            onSubmit={submitModifiedPermissions}
            samlLogin={currentUser.sign_in_method.signInMethod === 'singleSignOn' && currentUser.sign_in_method.status === 'enabled'}
            loading={false}
            step={1}
            canManagePermission={permissions.canManagePermission}
            permissions={permissions}
            currentAccessScope={currentUser.access_scope === IAccessScope.system}
            features={featureIds}
            editingDisabled={false}
            featureEnabled={false}
            keylockerEnabled={keyLockerEnabled}
          />
          }
          {features.roles && <>
            <div className={cn(styles.bannerContainer, !editingDisabled && styles.dimmed)}>
              <IncontextBanner
                bannerType="note"
                description={translate('common.form.assigningRoleDescription') as string}
                title={translate('common.form.rolesNowIncluded') as string}
              />
            </div>

            <div className={styles.permissionsContainer}>
              <Accordion
                oneByOne={false}
                accordionData={[
                  {
                    headline: translate('common.form.existingPermissions') as string,
                    key: 'permissions',
                    onEdit: editingDisabled ? editPermissions : undefined,
                    view:
                      <UserForm
                        mode={FormMode.edit}
                        user={currentUser}
                        location={location}
                        onCancel={cancelEditingPermissions}
                        onSubmit={submitModifiedPermissions}
                        samlLogin={currentUser.sign_in_method.signInMethod === 'singleSignOn' && currentUser.sign_in_method.status === 'enabled'}
                        loading={false}
                        step={1}
                        canManagePermission={permissions.canManagePermission}
                        permissions={permissions}
                        currentAccessScope={currentUser.access_scope === IAccessScope.system}
                        features={featureIds}
                        editingDisabled={editingDisabled}
                        featureEnabled={true}
                        keylockerEnabled={keyLockerEnabled}
                      />
                  }
                ]}
              />
            </div>
            <Form center={false} onSubmit={(e) => { submitUser(e) }}>
              <div className={cn(styles.rolesContainer, !editingDisabled && styles.dimmed)}>
                <h2><Translate id='manageUser.administrators.form.roles' /></h2>
                <p>
                  {currentUser.access_scope === IAccessScope.system ?
                    (<Translate id='manageUser.administrators.form.userRolesDescription' />) : (<Translate id='manageUser.administrators.form.editRoleDescription' />)
                  }
                </p>

                <FormGroup>
                  <MultiSelect
                    getPopupContainer={(triggerNode) => triggerNode.parentElement}
                    help=""
                    label={translate('common.digicertManagerAccess') as string}
                    placeholder={translate('common.form.select')}
                    value={managers}
                    onChange={handleMultiManagerSelect}
                    allowClear={true}
                    size={FormFieldSize.XXL}
                    options={getAllManagers()}
                    validate={validateMultiManagerSelect}
                  />
                </FormGroup>

                {managers.length > 0 &&
                <>
                  {managers.map(manager => {
                    const appCode = getAllManagers()?.filter(m => m.value === manager)[0].app
                    return (
                      <>
                        <div key={manager} className={styles.roleGroupContainer}>
                          <div className={styles.roleGroup}>
                            <MultiSelect
                              key={manager}
                              getPopupContainer={(triggerNode) => triggerNode.parentElement}
                              help=""
                              label={getManagerName(appCode, keyLockerEnabled)}
                              placeholder={translate('common.form.select')}
                              onChange={handleManagerRoleSelect}
                              allowClear={true}
                              size={FormFieldSize.XXL}
                              onDeselect={handleClearMultiSelect}
                              validate={validateManagerRoleSelect}
                            >
                              {getManagerRoles(manager)?.map((item, index) => {
                                return (
                                  <Option
                                    key={item.label}
                                    value={item.value}
                                    label={item.label}
                                    onMouseEnter={() => displayToolTip(index)}
                                    onMouseLeave={() => displayToolTip(-1)}
                                  >
                                    <Tooltip
                                      title={item.description}
                                      placement='right'
                                    >
                                      {item.label}
                                    </Tooltip>
                                  </Option>
                                )
                              })}
                            </MultiSelect>
                          </div>
                          {roleDetails.length >= 1 && roleDetails.filter(roleDet => roleDet.application === manager).length > 0 &&
                          <div className={styles.roleGroup}>
                            <Collapse collapsed={true}>
                              {roleDetails.map((roleDetail, roleIndex) => {
                                if (roleDetail.application === manager) {
                                  return (
                                    <div className={styles.role} key={roleIndex}>
                                      <div className={styles.roleHeader}>
                                        <i className={styles.roleIcon}>{roleDetail.icon}</i>
                                        <Link className={styles.roleLink} to='#'>{roleDetail.name}</Link>
                                        <Tag type={TagType.INACTIVE}>{roleDetail.type}</Tag>
                                      </div>
                                      <p className={styles.roleDescription}>{roleDetail.description}</p>
                                      <dl className={styles.roleInfo}>
                                        {roleDetail.permissionsGroups.map((permissionGroup, permissionGroupIndex) => {
                                          return (
                                            <div key={permissionGroupIndex}>
                                              <dt className={styles.roleCategory}>{permissionGroup.permissionGroupCategory}</dt>
                                              {permissionGroup.permissionGroups.map((group) => {
                                                return (
                                                  <>
                                                    <dd className={styles.roleName}>{group}</dd>
                                                  </>
                                                )
                                              })}

                                            </div>
                                          )
                                        })}
                                      </dl>
                                    </div>
                                  )
                                }
                              })}
                            </Collapse>
                          </div>
                          }
                        </div>
                      </>)
                  })}
                </>
                }
              </div>

              <div className={cn(styles.formActions, !editingDisabled && styles.dimmed)}>
                <Button buttonType={ButtonType.SECONDARY} onClick={(e) => { cancelEditingUser(e) }}>
                  <Translate id='common.form.buttons.cancelBtn' />
                </Button>

                <Button buttonType={ButtonType.SECONDARY} onClick={() => setCurrentPage(0)}>
                  <Translate id='common.form.buttons.backBtn' />
                </Button>

                <SubmitButton disabled={currentUser.access_scope !== IAccessScope.system && accounts.length === 0}>
                  <Translate id='manageUser.administrators.form.editAdmin' />
                </SubmitButton>
              </div>
            </Form>
          </>
          }
        </section>
      )}
    </>
  )
}

export default connect(
  (state: IAppState, ownProps: IEditUserOwnProps): IEditUserStateProps => ({
    permissions: getPermissions(state),
    user: state.users.items.find(user => user.id === ownProps.match.params.id),
    allPermissions: get(state, 'profile.permissions', {}),
    userApplications: state.userApplications.data,
    profile: state.profile.data,
    systemAccount: state.tenants.items[0],
    features: state.features,
    localeList: state.locales
  }),
  { fetchUserById, editUser, destroyForm, fetchPermissions, fetchTenantById, fetchRoles, checkIfUsernameExists, fetchUserRoleById, fetchUserApplications }
)(withPermissionsHOC(EditUser, ['canViewUser']))